const scrollTo = (elementId: string, options: ScrollIntoViewOptions = { behavior: "smooth" }) => {
	const element: HTMLElement | null = document.getElementById(elementId);

	if (!element) return;

	element.scrollIntoView(options);
};

export default scrollTo;
